import { Component, OnInit } from '@angular/core';
import { BaseBusinessCoupon } from '../../base-businessCoupon';
import { CouponService } from 'app/core/services/coupon.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';

@Component({
  selector: 'app-coupons-mobile',
  templateUrl: './coupons-mobile.component.html',
  styleUrl: './coupons-mobile.component.scss'
})
export class CouponsMobileComponent extends BaseBusinessCoupon implements OnInit {
displaySidebar:boolean=false
  constructor(public localizationService: LocalizationService, public commonService: CommonService,public couponService:CouponService, public messageService: AdvMessageService) {
    super(couponService,localizationService,commonService,messageService)
  }
  ngOnInit(): void {
    this.init()
    this.loadBusinessCoupons()
  }
}
